import { FC } from 'react';
import ReactDOM from 'react-dom';
import tdk from '@/constants/tdk';
import styles from './index.module.scss';
import { GetServerSidePropsContext } from 'next';
import CircleCard from './components/circleCard';
import CommonHead from '@/components/CommonHead';
import { getNavsList, ITopLevelNav } from '@/api/nav';
import { namespace } from '@/context';
import { ChannelCircle, getAllChannelCircles } from '@/api/home';
import useBodyContainer from '@/hooks/useBodyContainer';

interface CircleListProps {
  error?: Error[];
  circleList: ChannelCircle[];
}


interface Error {
  message: string;
  code: string | number;
};

// 圈子列表
const CircleList: FC<CircleListProps> = (props) => {

  const { circleList = [] } = props;
  const container = useBodyContainer();

  return (
    <div className={styles.circleContent}>
      <CommonHead {...tdk[namespace.group]} />
      {container &&
        ReactDOM.createPortal(
        '圈子 - 大疆社区',
        container
      )}
      <h1 className={styles.circleTitle}>所有圈子</h1>
      <div className={styles.circleList}>
        {(circleList[0]?.sub_circle_list || []).map((item) => (
          <CircleCard className={styles.circleCardItem} key={item.slug} {...item}  />
        ))}
      </div>
    </div>);
};

const handlePromiseResult = (result:  PromiseSettledResult<any>, setValue: ((value: any) => void), errorList: Error[]) => {
  if (result?.status === 'fulfilled') {
    setValue(result.value || []);
  } else {
    errorList.push(result.reason);
  }
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const headers = ctx.req ? ctx.req.headers : {};

  let error: Error[] = [];
  let navList: ITopLevelNav[] = [];
  let circleList: ChannelCircle[] = [];
  try {
    const [navs, circles] = await Promise.allSettled([
      getNavsList(true),
      getAllChannelCircles(true, headers)
    ]);

    handlePromiseResult(navs, (value: typeof navList) => (navList = value), error);
    handlePromiseResult(circles, (value: typeof circleList) => (circleList = value), error);
  } catch (e) {
  }

  return {
    props: {
      error,
      navList,
      circleList
    },
  };
}

export default CircleList;
